import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lms-detail',
  templateUrl: './lms-detail.component.html',
  styleUrls: ['./lms-detail.component.scss']
})
export class LmsDetailComponent implements OnInit {
  lms_id:any
  lmsData:any
  lmsArrayLength:number
  constructor(public toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private apiService: StrapiApiService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) {
    this.activatedroute.params.subscribe(data => {
      this.lms_id = data.id
    })
  }
  copyToClipboard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Content copied')
  }
  ngOnInit(): void {
  
      this.getLmsById();

  }


  getLmsById() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getLmsV1ById(this.lms_id).subscribe((res: any) => {
      this.lmsData = res
      this.spinner.hide()
let arr=Object.keys(this.lmsData)
    arr = arr.filter((key) => {
     for(let i in arr){
      if(key=='video'+i){
        return key
      }
     }
    })
      // if (!this.pt || this.pt == null) {
      //   this.open(this.myModal);
      // }
      // this.tags_p = res.rb_tags;
      // let content: any = {
      //   content: ''
      // }
      // this.cData = res;
      // if (localStorage.getItem('pt')) {
      //   this.collection = this.cData;
      // }
    })
  }


  ngOnDestroy() {
  }

}
